import React from "react";

export const BrandName = ({ tm = false }) => (
  <span className="whitespace-nowrap">
    <span className="text-[#3CC54F]">Dubble</span>
    <span className="text-[#3CABDA]">Upp</span>
    {tm && "™"}
  </span>
);
